console.log("Nordaus Featured JS Loaded");

document.addEventListener("DOMContentLoaded", () => {

  const cards = document.querySelectorAll(".nd-fc-card");

  cards.forEach(card => {

    const slides = card.querySelectorAll(".nd-fc-slide");
    const dots = card.querySelectorAll(".nd-fc-dots span");

    const prev = card.querySelector(".nd-fc-arrow-left");
    const next = card.querySelector(".nd-fc-arrow-right");

    if (slides.length <= 1) return;

    let current = 0;

    let startX = 0;
    let endX = 0;

    // ----------------------------
    // Initial State
    // ----------------------------

    slides.forEach((slide, index) => {
      slide.classList.toggle("active", index === 0);
    });

    dots.forEach((dot, index) => {
      dot.classList.toggle("active", index === 0);
    });

    // ----------------------------
    // Show Slide
    // ----------------------------

    function showSlide(index) {

      slides[current].classList.remove("active");
      dots[current].classList.remove("active");

      current = index;

      slides[current].classList.add("active");
      dots[current].classList.add("active");

    }

    // ----------------------------
    // Next
    // ----------------------------

    next.addEventListener("click", (e) => {

      e.preventDefault();
      e.stopPropagation();

      let index = current + 1;

      if (index >= slides.length) {
        index = 0;
      }

      showSlide(index);

    });

    // ----------------------------
    // Previous
    // ----------------------------

    prev.addEventListener("click", (e) => {

      e.preventDefault();
      e.stopPropagation();

      let index = current - 1;

      if (index < 0) {
        index = slides.length - 1;
      }

      showSlide(index);

    });

    // ----------------------------
    // Dots
    // ----------------------------

    dots.forEach((dot, index) => {

      dot.addEventListener("click", (e) => {

        e.preventDefault();
        e.stopPropagation();

        showSlide(index);

      });

    });

    // ----------------------------
    // Mobile Swipe
    // ----------------------------

    const imageArea = card.querySelector(".nd-fc-slider");

    if (imageArea) {

      imageArea.addEventListener("touchstart", (e) => {

        startX = e.touches[0].clientX;

      }, { passive: true });

      imageArea.addEventListener("touchend", (e) => {

        endX = e.changedTouches[0].clientX;

        const distance = startX - endX;

        const SWIPE_THRESHOLD = 50;

if (Math.abs(distance) < SWIPE_THRESHOLD) return;

        // Swipe Left
        if (distance > 0) {

          let index = current + 1;

          if (index >= slides.length) {
            index = 0;
          }

          showSlide(index);

        }

        // Swipe Right
        else {

          let index = current - 1;

          if (index < 0) {
            index = slides.length - 1;
          }

          showSlide(index);

        }

      }, { passive: true });

    }

  });

});